import { useDataChainId } from '@ui/hooks/datachain';
import { TradePair } from '@ui/types/tradePair';
import { useCallback } from 'react';

import { useFromInput } from '../hooks/useFromInput';
import { useTradingPair } from './useTradingPair';

export const useSetTradingPair = () => {
  const chainId = useDataChainId();

  // reset limit order price
  const setInput = useFromInput((s) => s.setInput);
  const input = useFromInput((s) => s.input);

  return useCallback(
    (tradingPair: TradePair) => {
      useTradingPair.getState().setTradingPair(tradingPair, chainId);
      setInput({
        ...input,
        triggerPrice: null,
      });
    },
    [chainId, input, setInput],
  );
};
